const draggable = {}

draggable.install = (Vue) => {
    Vue.directive('draggable', {
        inserted: function (el, binding) {
            let offsetX, offsetY
            let minX, maxX, minY, maxY

            // 通过binding.value来获取传递的参数
            const maxTop = binding.value && binding.value.maxTop ? binding.value.maxTop : Infinity

            function onMouseDown(event) {
                offsetX = event.clientX - el.getBoundingClientRect().left
                offsetY = event.clientY - el.getBoundingClientRect().top

                minX = 0
                maxX = window.innerWidth - el.offsetWidth
                // 限制最多只能拖拽到顶部maxTop
                minY = Math.max(window.scrollY, window.scrollY + maxTop)
                maxY = window.innerHeight - el.offsetHeight

                document.addEventListener('mousemove', onMouseMove)
                document.addEventListener('mouseup', onMouseUp)
            }

            function onMouseMove(event) {
                let newX = event.clientX - offsetX
                let newY = event.clientY - offsetY

                // 边界检查
                newX = Math.min(Math.max(newX, minX), maxX)
                newY = Math.min(Math.max(newY, minY), maxY)

                el.style.left = newX + 'px'
                el.style.top = newY + 'px'
            }

            function onMouseUp() {
                document.removeEventListener('mousemove', onMouseMove)
                document.removeEventListener('mouseup', onMouseUp)
            }

            el.addEventListener('mousedown', onMouseDown)
        }
    })
}

export default draggable
